import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { filter, map } from 'rxjs/operators';

@UntilDestroy()
@Injectable()
export class PageTitleService {
    constructor(
        private _title: Title,
        private _router: Router,
        private _route: ActivatedRoute,
        private _translateService: TranslateService
    ) {}

    trackTitleChanges() {
        this._router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                map(() => {
                    let child = this._route.firstChild;
                    const pages = [];
                    while (child) {
                        if (
                            child.snapshot.component &&
                            child.snapshot.data['title'] &&
                            pages.indexOf(this._translateService.instant(child.snapshot.data['title'])) < 0
                        ) {
                            pages.push(this._translateService.instant(child.snapshot.data['title']));
                        }
                        child = child.firstChild;
                    }
                    return pages;
                })
            )
            .subscribe((pages) => {
                this._title.setTitle(this._buildTitle(pages));
            });
    }

    private _buildTitle(pages: string[]): string {
        pages.push(this._translateService.instant('APP.NAME'));
        return pages.join(' - ');
    }
}
